import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import moment from 'moment';
import { Highcharts } from 'javascripts/analytics/config/highcharts';
import { ChartLegendBox } from 'javascripts/analytics/components/chart_legend_box';
import { transformToDayCounts } from 'javascripts/analytics/config/utilities';

const CHART_COLORS = {
  VIEWS: '#78A634',
  DOWNLOADS: '#6D181F',
};

const getChartConfig = function (startDate) {
  // We add 1 to the date to make sure the last data point is at today, or
  // finish
  const pointStart = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
  ).valueOf();

  return {
    defaultChartConfig: {
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'datetime',
        tickInterval: 24 * 3600 * 1000,
        tickWidth: 1,
        dateTimeLabelFormats: {
          month: '%b %e',
          day: '%b %e',
        },
        labels: {
          step: 4,
          staggerLines: 1,
          y: 25,
        },
      },
      yAxis: {
        title: false,
        min: 0,
        allowDecimals: false,
        gridLineColor: '#E9E9E9',
      },
      legend: {
        enabled: false,
      },
      title: {
        text: undefined,
      },
      tooltip: {
        shared: true,
        crosshairs: true,
      },
    },
    defaultSeriesConfig: {
      pointStart: pointStart,
      pointInterval: 24 * 3600 * 1000,
      shadow: false,
      marker: {
        symbol: 'circle',
        radius: 4,
        fillColor: '#FFFFFF',
        lineColor: null,
        lineWidth: 2,
      },
    },
  };
};

export const DocumentsTabChart = createReactClass({
  propTypes: {
    hits: PropTypes.array.isRequired,
    downloads: PropTypes.array.isRequired,
    startDate: PropTypes.object.isRequired,
    previousDateRangeDownloads: PropTypes.array.isRequired,
    previousDateRangeHits: PropTypes.array.isRequired,
    dayCount: PropTypes.number.isRequired,
  },

  initializeLineGraph: function (el) {
    if (!el) return;
    const config = getChartConfig(this.props.startDate);

    const groupedHits = _.chain(this.props.hits)
      .filter(function (hit) {
        return hit.page && hit.page.work_id;
      })
      .groupBy(function (hit) {
        return moment.unix(hit.epoch / 1000).format('YYYY-MM-DD');
      })
      .value();

    const groupedDownloads = _.groupBy(
      this.props.downloads,
      function (download) {
        return moment.unix(download.epoch / 1000).format('YYYY-MM-DD');
      },
    );

    const hitsByDay = transformToDayCounts(groupedHits);
    const downloadsByDay = transformToDayCounts(groupedDownloads);

    const series = _.map(
      [hitsByDay, downloadsByDay],
      function (singleSeries, index) {
        return _.extend(
          {
            name: ['Views', 'Downloads'][index],
            data: singleSeries,
            color: [CHART_COLORS.VIEWS, CHART_COLORS.DOWNLOADS][index],
          },
          config.defaultSeriesConfig,
        );
      },
    );
    const customChartConfig = {
      chart: {
        type: 'line',
        renderTo: el,
      },
      series: series,
    };
    const chartConfig = _.extend(customChartConfig, config.defaultChartConfig);
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const latestChart = new Highcharts.Chart(chartConfig);
  },

  workHitCountFromHits: function (hits) {
    return _.filter(hits, function (hit) {
      return hit.page.work_id;
    }).length;
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  render: function () {
    return (
      <div className="panel panel-flat a-fadeInDown">
        <div className="u-p5x u-tcGrayDarker">Paper Engagement</div>
        <div className="panel-horizontal-split" />
        <div className="panel-body">
          <div
            ref={this.initializeLineGraph}
            key={this.props.hits.length + '-' + this.props.downloads.length}
          ></div>
        </div>
        <div className="panel-horizontal-split" />
        <div className="row u-m0x">
          {_.map(
            [
              {
                label: this.props.dayCount + '-day Views',
                color: CHART_COLORS.VIEWS,
                count: this.workHitCountFromHits(this.props.hits),
                previousDateRangeCount: this.workHitCountFromHits(
                  this.props.previousDateRangeHits,
                ),
                dayCount: this.props.dayCount,
              },
              {
                label: this.props.dayCount + '-day Downloads',
                color: CHART_COLORS.DOWNLOADS,
                count: this.props.downloads.length,
                previousDateRangeCount:
                  this.props.previousDateRangeDownloads.length,
                dayCount: this.props.dayCount,
              },
            ],
            function (props, index) {
              return (
                <div
                  className="col-xs-6 panel-vertical-split u-p0x"
                  key={index}
                >
                  <ChartLegendBox {...props} />
                </div>
              );
            },
          )}
        </div>
      </div>
    );
  },
});
